import React from 'react';
import PropTypes from 'react';
import styled from 'styled-components';
import { Field } from 'redux-form';

const Label = styled.label`
  cursor: pointer;
  padding: 10px 5px;
`;

const Checkbox = styled.input`
  margin: 0 5px;
  padding: 10px 5px;
  display: inline-block;
`;

export default function MultiSelectGroup({ options, name, label }) {
  return (
    <div>
      {label}
      <div>
        {options.map(({ value, label }) => {
          const key = `${name}_${value}`;
          return (
            <Label key={key} htmlFor={key}>
              <Field
                type="radio"
                name={name}
                id={key}
                value={`${value}`}
                component={({ input, ...rest }) => {
                  return <Checkbox name={name} {...input} {...rest} />;
                }}
              />
              {label}
            </Label>
          );
        })}
      </div>
    </div>
  );
}

MultiSelectGroup.propTypes = {
  options: PropTypes.array,
  name: PropTypes.string,
  label: PropTypes.string
};
